// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3OOTH","colMaxWidth":"Table_colMaxWidth__3oFv5"};